<div class="flex flex-col h-auto gap-4 side-padding sm:px-0">
  <div
    class="flex flex-col w-full gap-3 p-5 pb-0 bg-white max-sm:p-3 max-sm:pb-0 rounded-10"
  >
    <!-- Competition details loading -->
    @if (this.fetchStatusComputed().isLoading) {
    <app-competition-details-skeleton />
    }

    <!-- Competition details data -->
    @if (!this.fetchStatusComputed().isLoading && this.competition()) {
    <div>
      <app-football-breadcrumbs [data]="this.getCompetitionBreadcrumbsData()" />
      <app-competition-details-card
        [competitionDetails]="this.getCompetitionDetailsData()"
      />
    </div>
    <app-competition-tabs (onSelectTab)="handleSelectTab($event)" />
    }
  </div>

  <!--  -->
  @if(!this.fetchStatusComputed().isError &&
  !this.fetchStatusComputed().isLoading && this.competition()) {
  <!-- Tabs -->
  @switch (selectedTab()) {
  <!-- MATCHES -->
  @case (0) {
  <app-matches />
  }
  <!-- RESULTS -->
  @case (1) {
  <app-results />
  }
  <!-- STANDING -->
  @case (2) {
  <app-standings [competitionId]="competitionId()" />
  }
  <!-- DEFAULT -->
  @default {
  <app-no-result message="NotAvalaibleInformation" />

  } } }
</div>
